import initialProject from 'helpers/projects/initialProject'

export default camera => ({ ...initialProject(`Model ${camera.model.model}`), cameras: [camera] })



// WEBPACK FOOTER //
// ./src/sagas/setupProjectsSaga/projectWithModel.js